export const ORDERS = "/orders";
export const OPERATIONS = "/operations";
export const TIMELINE_GROUPS = "/timeline-groups";
